import React from 'react'
import { Button } from '@/shared/ui'

interface ReopenModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: () => void | Promise<void>
  courierName?: string
  loading?: boolean
}

export const ReopenModal: React.FC<ReopenModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  courierName,
  loading = false,
}) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-40 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6 space-y-4">
          <h2 className="text-xl font-semibold text-gray-900">Пересмотреть заявку</h2>
          <p className="text-sm text-gray-600">
            Вернуть заявку{courierName ? ` «${courierName}»` : ''} на модерацию?
            Возврат не означает одобрения и не активирует курьера.
          </p>
        </div>
        <div className="flex justify-end gap-3 p-6 border-t bg-gray-50">
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Отмена
          </Button>
          <Button variant="primary" onClick={() => void onSubmit()} isLoading={loading}>
            Вернуть на модерацию
          </Button>
        </div>
      </div>
    </div>
  )
}
